/*
 *
 * Package: `@dbh/is-gdpr-compliance-mode-disabled`.
 *
 */

/**
 * Returns `true` if the `GDPR` compliance mode is disabled (we use the
 * runtime env). WARNING: it should only be disabled for temporary tests agreed
 * with the company, otherwise the company can face big legal issues and fines.
 * @return {boolean} .
 */
const isGDPRComplianceModeDisabled = () => process.env.IS_GDPR_COMPLIANCE_MODE_DISABLED === 'true';

export { isGDPRComplianceModeDisabled as default };
